<div class="bp-modal mod-lg">
	<bp-modal-header [title]="'uk_customer_segmentation_appropriateness_test.modal_title' | translate" [cssStyle]="'mod-general border'">
		@if(showBackButton()) {
			<a
				left
				(click)="backClick()"
				(keydown.enter)="backClick()"
				[tabIndex]="0"
				class="large-weight">
				{{ "back" | translate }}
			</a>
		}
	</bp-modal-header>
	<div class="bp-modal-body min-h-560">
		<div class="bp-modal-body-section pl-0 pr-0 pt-40 pb-80">
			<div class="main-content cs-main-content">
				<!-- Part 1 - Intro -->
				@if(isIntroStep()) {
					<ng-container>
						<customer-segmentation-intro></customer-segmentation-intro>
					</ng-container>
				} @else {
				<!-- Part 2 - Questions -->
					<ng-container>
						<div class="cs-questions-container">
							@if(isStep(2)) {
								<investor-profile
									[question]="getCurrentQuestions(flowId, step)[0]">
								</investor-profile>

							}
							@if(flowId === 1) {
								<ng-container>
									@if(isStep(3)) {
										<restricted-investor-statement
											[question]="getCurrentQuestions(flowId, step)[0]">
										</restricted-investor-statement>
									}
									@for (question of getCurrentQuestions(flowId, step); track question) {
										<ng-container>
											@if(isStep(4)) {
												<investor-questions
													[question]="question">
												</investor-questions>
											}
										</ng-container>
									}
									@for (question of getCurrentQuestions(flowId, step); track question) {
										<ng-container>
											@if(isStep(5)) {
												<investor-questions
													[question]="question">
												</investor-questions>
											}
										</ng-container>
									}

									@if(isStep(6)) {
										<investor-agreement
											[question]="getCurrentQuestions(flowId, step)[0]">
										</investor-agreement>
									}
								</ng-container>
							}

							<!-- High Net Investor Questions -->
							@if(flowId === 2) {
								<ng-container>
									@for (question of getCurrentQuestions(flowId, step); track question) {
										<ng-container>
											@if(isStep(3)) {
												<investor-questions
													[question]="question">
												</investor-questions>
											}
										</ng-container>
									}

									@if(isStep(4)) {
										<investor-agreement
											[question]="getCurrentQuestions(flowId, step)[0]">
										</investor-agreement>
									}
								</ng-container>
							}
						</div>
					</ng-container>
				}
				<div class="button-footer">
					@if(isLastQuestion() && notAnRestrictedInvestor()) {
						<ng-container>
							<end-crypto-journey [question]="getCurrentQuestions(flowId, step)[0]"></end-crypto-journey>
							<div class="bottom-button-container flex-col button-group customer-segmentation-wrapper">
								<button
									class="btn btn-primary btn-wide btn-lg btn-semibold"
									(click)="changeAnswers()"
									(keydown.enter)="changeAnswers()">
									{{ "uk_customer_segmentation_14_neither.change_answer" | translate }}
								</button>
								<a
									class="link"
									style="padding-top: 16px;"
									(click)="onContinue()">
									{{ "uk_customer_segmentation_appropriateness_test.questions.neither.one.answers.one" | translate }}
								</a>
							</div>
						</ng-container>
					} @else {
						<ng-container>
							<div class="bottom-button-container customer-segmentation-wrapper continue-button">
								<button
									class="btn btn-primary btn-wide btn-lg btn-semibold"
									(click)="onContinue()"
									[disabled]="isButtonDisabled()">
									{{ getButtonKey() | translate }}
								</button>
							</div>
						</ng-container>
					}
				</div>
			</div>
		</div>
	</div>
</div>
